import React, { useCallback } from 'react';
import { withTranslation } from 'react-i18next';

import SelectTaskGroupPopout from 'components/SelectTaskGroupPopout';
import Tooltip from 'components/tooltip';

const TaskArchiveToggle = ({ projectId, archived, completed, tooltipEnabled, onArchive, onUnarchive, children, t }) => {
    const handleClick = useCallback(() => {
        if (archived) {
            onUnarchive();
        } else {
            onArchive();
        }
    }, [archived]);

    const handleTaskGroupSelect = ({ id }) => {
        onUnarchive(id);
    }

    const childrenWithProps = React.cloneElement(children, {
        onClick: handleClick
    });

    return (
        <Tooltip showDelay={200} tooltip={archived ? t('actions.Unarchive task') : t('actions.Archive task')} disabled={!tooltipEnabled}>
            {
                archived && !completed ? (
                    <SelectTaskGroupPopout
                        projectId={projectId}
                        withProject={false}
                        onSelect={handleTaskGroupSelect}
                    >
                        { children }
                    </SelectTaskGroupPopout>
                ) : childrenWithProps
            }
        </Tooltip>
    );
}

export default withTranslation('task')(TaskArchiveToggle);
